/* global $ */
import Headroom from 'headroom.js'

import './jquery.slicknav.js'

import './slicknav.css'

const setSlickNav = async () => {
  $('#menu').slicknav({
    closedSymbol: '+',
    openedSymbol: '<span class="opened">-</div>',
    closeOnClick: true
  })

  let slickNavElem = document.querySelector('.slicknav_menu')
  let slickNavNavElem = document.querySelector('.slicknav_nav')

  let logo = document.querySelector('.logo') // Get logo
  if (logo) { // Add logo
    let logoElem = document.createElement('div')
    logoElem.className = 'slicknav_menu__logo'
    logoElem.innerHTML = logo.innerHTML
    slickNavElem.appendChild(logoElem)
  }


  let buttons = document.querySelector('.site-header .main-navigation .buttons') // Get buttons
  if (buttons) { // Add buttons
    let buttonsElem = document.createElement('div')
    buttonsElem.className = 'slicknav_menu__buttons'
    buttonsElem.innerHTML = buttons.innerHTML
    slickNavElem.appendChild(buttonsElem)
    slickNavNavElem.appendChild(buttonsElem.cloneNode(true))
  }

  return slickNavElem
}

const setHeadroom = (slickNavElem) => {
  if (slickNavElem) {
    const headroom = new Headroom(slickNavElem, {
      offset: 200,
      tolerance: 5,
      classes: {
        // When element is initialised
        initial: 'headroom--mobile',
        // When scrolling up
        pinned: 'headroom--pinned--mobile',
        // When scrolling down
        unpinned: 'headroom--unpinned--mobile'
      },
      // Cancel unpin when Slick nav is open
      onUnpin: function () {
        if ($('.slicknav_open')[0]) this.pin()
      }
    })
    headroom.init()
  }
}

const init = async () => {
  await setSlickNav().then(setHeadroom) // Initialize SlickNav, then set headroom
}

export default {
  init
}
